import { Base } from "../../framework/base";
import { IdTitle, IIdTitle } from "../common/idTitle";
import { IdTitleNode, IIdTitleNode } from "../common/idTitleNode";
import { IRecordCompanyFurtherEducationGroups, RecordCompanyFurtherEducationGroups } from "../recordFurtherEducationGroup/recordCompanyFurtherEducationGroups";

export interface IAppReportRecordReferenceData {
    recordCharts: IIdTitle[];
    recordUnits: IIdTitleNode[];
    recordFurtherEducationGroups: IRecordCompanyFurtherEducationGroups[];
}

export class AppReportRecordReferenceData implements IAppReportRecordReferenceData {
    recordCharts: IdTitle[];
    recordUnits: IdTitleNode[];
    recordFurtherEducationGroups: RecordCompanyFurtherEducationGroups[];

    constructor();
    constructor(obj: IAppReportRecordReferenceData);
    constructor(obj?: any) {
        this.recordCharts = Base.getTypedArray(obj?.recordCharts, IdTitle);
        this.recordUnits = Base.getTypedArray(obj?.recordUnits, IdTitleNode);
        this.recordFurtherEducationGroups = Base.getTypedArray(obj?.recordFurtherEducationGroups, RecordCompanyFurtherEducationGroups);
    }
}
